/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function TerminalIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "terminal", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M8 9L11.5 12.5L8 16M13 16H18M3.5 4.5H21.5V20.5H3.5V4.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(TerminalIcon);
export default ForwardRef;
//# sourceMappingURL=terminalIcon.js.map